import React from "react";
import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import { Helmet } from "react-helmet";
import validate from "validate.js";
import CryptoJS from "crypto-js";

import { enUS } from './en-US.js';
import { zhHK } from './zh-HK.js';
import { host, api11, busiSecKey } from '../../config/api.js';
import { formStyles } from '../../config/styles.js';
import { clearEmptyStrings, hmacSha256, msgCodeDetail } from '../../lib/utils.js';
import { memberStorage } from '../../lib/MemberStorage.js';
import { languageStorage } from '../../lib/LanguageStorage.js';
import Locale from '../../Locale.js';
import TextInput from '../../components/TextField/TextField.js';
import Navbar from '../../components/Navbar/Navbar.js';
import Footer from '../../components/Footer/Footer.js';
import ModalOTP from "../../components/ModalOTP/ModalOTP.js";
import PasswordPolicyTooltip from "../../components/Tooltip/PasswordPolicyTooltip.js";
import Alert from "../../components/Alert/Alert.js";
import YesNoRadio from "../../components/YesNoRadio/YesNoRadio.js";
import Member from "../../Member.js";

export default class ChangePasswordScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: {},
      messages: {},
      isUseSMS:"Y" // "Y" || "N"
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const getText = (language) => {
      let text = enUS;
      if (language == "zhHK") {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage((language) =>
      this.setState({
        language: language,
        text: getText(language),
      })
    );

    memberStorage.getMember((member) => {
      if(member){
        this.setState({ mobileNumber: member.mobile });
      }
    });
  }

  showError(text) {
    this.setState({
      alert: Alert.alert(this.state.text.alert, text || "Some Error happen" , [
        {
          text: this.state.text.ok,
          onPress: () => {
            this.setState({ alert: null });
          },
        },
      ]),
    });
  }
  async _checkPasswordVerify() {
    const data = JSON.stringify({
      username: this.state.mobileNumber,
      password: this.state.oldPassword,
      timeStamp: Date.now(),
    });

    const hmac = hmacSha256(data);

    try {
      const response = await fetch(host + "/member/password/verify", {
        method: "POST",
        credentials: 'include',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
      });

      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return false;
    }
  }

  async _sendShortMessage(isSendEmail) {
    const data = JSON.stringify({
      mobile: this.state.mobileNumber,
      isSendEmail: isSendEmail ? "Y" : "N",
      timeStamp: Date.now(),
    });

    const hmac = hmacSha256(data);

    try {
      const response = await fetch(host + api11, {
        method: "POST",
        credentials: 'include',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
      });

      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return false;
    }
  }

  async _clickChangePasswordButton() {
    const state = clearEmptyStrings(this.state);

    let attributes = {
      mobileNumber: this.state.mobileNumber,
      oldPassword: this.state.oldPassword,
      newPassword: this.state.newPassword,
    };

    let constraints = {
      mobileNumber: {
        presence: { message: this.state.text.thisFieldCannotBeBlank },
        numericality: { message: this.state.text.invalidMobileNumber },
        length: { is: 8, message: this.state.text.invalidMobileNumber },
      },
      oldPassword: {
        presence: { allowEmpty: false, message: this.state.text.passwordCannotBeBlank },
      },
      newPassword: {
        passwordPolicy: true,
      },
    };

    const messages = validate(attributes, constraints, { fullMessages: false });

    if (messages) {
      this.setState({ messages: messages });
      return;
    }

    if (this.state.shortMessageSending) {
      return;
    }
    
    this.setState({
      messages: {},
      shortMessageSending: true,
      shortMessageSent: false,
    });
    
    // check password is correct
    const checkPasswordVerifyRes = await this._checkPasswordVerify();
    if (checkPasswordVerifyRes.msgCode !== 0) {
      this.setState({ shortMessageSending: false });
      this.showError(this.state.text.incorrectPassword);
      return;
    }
    
      // new password should not be the same as old password
      if(this.state.oldPassword === this.state.newPassword){
        this.setState({ shortMessageSending: false });
        this.showError(
          msgCodeDetail(88)[
            this.state.language === "enUS" ? "desc_en" : "desc_zh"
          ]
        );
        return;
      }
    
    const sendShortMessageRes = await this._sendShortMessage(this.state.isUseSMS === "N");
    if (sendShortMessageRes.msgCode === 0) {
      this.setState({
        targetPhoneNumber: this.state.mobileNumber,
        shortMessageSent: true,
      });
    } else {
      this.showError(
        msgCodeDetail(sendShortMessageRes.msgCode)[
          this.state.language === "enUS" ? "desc_en" : "desc_zh"
        ]
      );
    }
    this.setState({ shortMessageSending: false });
  }

  async _changePassword(otpCode) {
    if (this.state.loggingIn || !otpCode) {
      return;
    }
    this.setState({ loggingIn: true });
    const data = JSON.stringify({
      username: this.state.mobileNumber,
      old_password: this.state.oldPassword,
      new_password: this.state.newPassword,
      verify_code: otpCode,
      timeStamp: Date.now(),
    });

    try {
      const key = CryptoJS.AES.decrypt(
        busiSecKey,
        "ACTj4a4589rxPEIW2PoE"
      ).toString(CryptoJS.enc.Utf8);

      const hmac = hmacSha256(data);

      const response = await fetch(host + "/member/password/update", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
        credentials: 'include',
      });

      const responseJson = await response.json();
      if (responseJson.msgCode === 0) {
        this.showError(this.state.text.passwordChangeSuccess);
        this.setState({oldPassword:"",newPassword:""})
      } else {
        this.showError(
          msgCodeDetail(responseJson.msgCode)[
            this.state.language === "enUS" ? "desc_en" : "desc_zh"
          ]
        );
        this.setState({ loggingIn: false });
      }
    } catch (error) {
      this.showError(this.state.text.updatePasswordFailed);
      this.setState({ loggingIn: false });
    }
  }

  render() {
    const themeColor = Member.getThemeColor();
    return (
      <div className="App">
        <Helmet>
          <title>ChangePassword | Bravo Generali</title>
        </Helmet>

        <Navbar
          title={this.state.text.changePassword}
          backButton
          history={this.props.history}
        />
        <Grid container spacing={20} style={{ backgroundColor: "#f2f2f2" }}>
          <Hidden xsDown>
            <Grid
              item
              xs
              style={{ marginBottom: 13, marginLeft: "5%", marginRight: "5%" }}
            >
              <View style={[styles.greeting, { fontWeight: "bold" }]}>
                <Text
                  style={[
                    styles.greetingText,
                    { marginTop: "10%", fontSize: 35 },
                  ]}
                >
                  {this.state.text.changePassword}
                </Text>
              </View>
            </Grid>
          </Hidden>

          <Grid
            item
            xs
            style={{
              marginTop: 30,
              marginBottom: 50,
              backgroundColor: "white",
            }}
          >
            <ScrollView style={[formStyles.form, styles.fieldset]}>
              {this.state.alert}
              <View style={[formStyles.fieldset]}>
                <Text style={formStyles.h3}>
                  {Locale.text.changePasswordWithMobilePhone}
                </Text>
              </View>
              <form>
              <View style={[formStyles.fieldset]}>
                <Text style={formStyles.h4}>
                  {this.state.text.mobileNumber}
                </Text>
                <TextInput
                  style={formStyles.input}
                  onChangeText={(text) => this.setState({ mobileNumber: text })}
                  value={this.state.mobileNumber}
                  keyboardType="numeric"
                  editable={false}
                  autoComplete
                  name="username"
                />
                <Text style={formStyles.message}>
                  {this.state.messages.mobileNumber}
                </Text>
              </View>

              <View style={[formStyles.fieldset]}>
                <Text style={formStyles.h4}>{this.state.text.oldPassword}</Text>
                <TextInput
                  style={formStyles.input}
                  onChangeText={(text) => this.setState({ oldPassword: text })}
                  value={this.state.oldPassword}
                  keyboardType="password"
                  autoComplete
                  name="password"
                />
                <Text style={formStyles.message}>
                  {this.state.messages.oldPassword}
                </Text>
              </View>

              <View style={[formStyles.fieldset]}>
                <Text style={formStyles.h4}>{this.state.text.newPassword}<PasswordPolicyTooltip/></Text>
                <TextInput
                  style={formStyles.input}
                  onChangeText={(text) => this.setState({ newPassword: text })}
                  value={this.state.newPassword}
                  keyboardType="password"
                />
                <Text style={formStyles.message}>
                  {this.state.messages.newPassword}
                </Text>
              </View>
              <View style={formStyles.fieldset}>
                <YesNoRadio
                  choice={this.state.isUseSMS}
                  question={this.state.text.otpMethod}
                  questionStyle={{marginTop:"15px"}}
                  onChange={(v)=>this.setState({isUseSMS:v})}
                  noLabel={this.state.text.email}
                  yesLabel="SMS"
                />
              </View>


              {!this.state.shortMessageSent && (
                <View style={[formStyles.fieldset ]}>
                  {this.state.shortMessageSending ? (
                    <View style={{ marginTop: "1em" }}>
                      <View style={formStyles.submitButtonDisabled}>
                        <Text style={formStyles.submitButtonText}>
                          {this.state.text.pleaseWait}
                        </Text>
                      </View>
                    </View>
                  ) : (
                    <View style={{ marginTop: "1em" }}>
                      <TouchableOpacity
                        style={{...formStyles.submitButton,backgroundColor:themeColor}}
                        onPress={() => this._clickChangePasswordButton()}
                      >
                        <Text style={formStyles.submitButtonText}>{this.state.text.changePassword}</Text>
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
              )}
              </form>
            </ScrollView>
          </Grid>
          <Hidden xsDown>
            <div style={{ marginRight: "5%" }} />
          </Hidden>
        </Grid>
        <Footer />
        <ModalOTP
          open={this.state.shortMessageSent}
          onClose={() => this.setState({ shortMessageSent: false })}
          onSubmit={(optCode, isSaveDevice) => this._changePassword(optCode, isSaveDevice)}
          onResend={(bool)=>this._sendShortMessage(bool)}
        />
      </div>
    );
  }
}

const styles = {
  orStyle: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    fontSize: "14px",
    color: "grey",
    alignItems: "center",
    marginBottom:10
  },
  horizontalLine: {
    width: "100%",
    height: "1px",
    backgroundColor: "grey",
    flex: 1,
  },
  container: {
    flex: 1,
    alignItems: "stretch",
  },
  form: {
    minHeight: 500,
    paddingTop: 100,
  },
  fieldset: {
    margin: "auto",
    minWidth: 300,
    maxWidth: 600,
    minHeight: 620,
  },
  link: {
    color: "#C50000",
  },
};
